module.exports = __webpack_public_path__ + "static/media/patent_cn.85815440.25de67e7.jpg";